import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2023DatosGenerales() {
  return <CategoryPage category="anexo30Y31Ano2023DatosGenerales" pageTitle="Datos Generales 2023" />;
}

export default Anexo30Y31Ano2023DatosGenerales;
